import { render, staticRenderFns } from "./AnnihilationButton.vue?vue&type=template&id=508ee007"
import script from "./AnnihilationButton.vue?vue&type=script&lang=js"
export * from "./AnnihilationButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports